



























































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Message } from '@/@types/LibraryComponent';
import OrganizationIcon from '@/components/common/OrganizationIcon.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';
import { vxm } from '@/store';
import {
  Account,
  AccountRetentionSkill,
  AccountParticipationProject,
  FindAccountFootprintsQuery,
  AccountFootprintsResponse,
  FindOneAccountQuery,
} from '@/@types/Account';
import ProfileEvaluationCard from '@/components/profile/profileParts/ProfileEvaluationCard.vue';
import ParticipationConditionCard from '@/components/profile/profileParts/ParticipationConditionCard.vue';
import ParticipationProjectCard from '@/components/profile/profileParts/ParticipationProjectCard.vue';
import ProfileRatingStar from '@/components/profile/profileParts/ProfileRatingStar.vue';
import FootprintListModal from '@/components/profile/FootprintListModal.vue';

@Component({
  components: {
    OrganizationIcon,
    AccountIcon,
    ProfileEvaluationCard,
    ProfileRatingStar,
    FootprintListModal,
    ParticipationConditionCard,
    ParticipationProjectCard,
  },
})
export default class ProfileBase extends Vue {
  private account: Account | null = null;
  private accountParticipationProjects: AccountParticipationProject[] = [];
  private OrganizationAvatarSize: number = 32;
  private OrganizationAvatarColor: string = '#fa5f7e';
  private skills: AccountRetentionSkill[] = [];
  /** アカウント詳細取得用クエリパラメータ（仮置き） */
  private detailFlag: boolean = true;
  /** プロジェクト経験数の境界値を定義 */
  private OVER_PROJECT_COUNT: number = 10;
  /** 参画プロジェクトコメントのAPI設計が未定のため、仮置きのプロパティ */
  private participationProjectComment = 'aaa';
  /** アカウント評価最大値を示す定数 */
  private MAX_EVALUATION: number = 5;
  private loading: boolean = false;
  private accountLoading: boolean = true;
  private footprintsNumberLoading: boolean = true;
  private footprintsLoading: boolean = true;
  private participationProjectsLoading: boolean = true;
  private isResumeFileUploaded: boolean | null = false;

  /** プロフィール画面生成前に必要な情報を取得 */
  private async created() {
    const footPrintsQuery: FindAccountFootprintsQuery = { count: 8 };
    await Promise.all([
      vxm.theoryApi.accountsStore.fetchAccountDetail(this.accountId),
      vxm.theoryApi.accountsStore.fetchAccountTotalFootprints(this.accountId),
      vxm.theoryApi.accountsStore.fetchAccountParticipationProjects(this.accountId),
      vxm.theoryApi.accountsStore.fetchAccountFootprints({
        accountId: this.accountId,
        query: footPrintsQuery,
      }),
    ]);
    this.account = this.getAccount;
    this.accountParticipationProjects.push(...this.getAccountParticipationProjects);
    this.$nextTick(() => {
      this.accountLoading = false;
      this.footprintsNumberLoading = false;
      this.footprintsLoading = false;
      this.participationProjectsLoading = false;
    });
  }

  private editProfile() {
    this.$router.push({
      name: 'profileEdit',
      params: { id: `${this.accountId}` },
    });
  }

  private messageColor(val: Array<Message>): string {
    if (val === null) {
      return 'grey lighten-1';
    }
    return 'light-blue';
  }

  private skilChipColor(val: number): string | undefined {
    if (val < 1) {
      return 'grey lighten-2';
    } else if (10 <= val) {
      return 'pink accent-2';
    } else if (5 <= val) {
      return 'green accent-2';
    } else if (3 <= val) {
      return 'light-blue';
    } else if (1 <= val) {
      return 'amber';
    }
  }

  /** プロフィール画面表示用のアカウント住所を連結 */
  private getAccountAddress(): string {
    return `${this.account?.prefectureCd}${this.account?.cityCd}${this.account?.streetAddress}`;
  }

  /** プロフィール画面に表示する最後ログイン時間を算出するメソッド */
  private getAccountLastLoginTimeString(): string | null {
    const lastLoginTime = this.account?.lastLoginTime;
    if (lastLoginTime) {
      const difference =
        new Date().getTime() - new Date(lastLoginTime).getTime();
      const elapsedTime = new Date(difference);
      if (elapsedTime.getUTCFullYear() - 1970) {
        return `${elapsedTime.getUTCFullYear() - 1970}年前にログイン`;
      } else if (elapsedTime.getUTCMonth()) {
        return `${elapsedTime.getUTCMonth()}ヶ月前にログイン`;
      } else if (elapsedTime.getUTCDate() - 1) {
        return `${elapsedTime.getUTCDate() - 1}日前にログイン`;
      } else if (elapsedTime.getUTCHours()) {
        return `${elapsedTime.getUTCHours()}時間前にログイン`;
      } else if (elapsedTime.getUTCMinutes()) {
        return `${elapsedTime.getUTCMinutes()}分前にログイン`;
      } else {
        return `${elapsedTime.getUTCSeconds()}たった今ログイン`;
      }
    } else return null;
  }

  /** アカウントの各参画プロジェクトに星5の評価が含まれているかどうかを検証 */
  private get includesMaxEvaluation(): boolean {
    return this.accountParticipationProjects.some((project) => {
      return [
        project.technicalSkills,
        project.communicationSkills,
        project.understandingSkills,
      ].includes(this.MAX_EVALUATION);
    });
  }

  /** アカウント参画プロジェクトの総数が10以上であるかどうかを検証 */
  private get overCountProjects(): boolean {
    return this.accountParticipationProjects.length >= this.OVER_PROJECT_COUNT;
  }

  /** ヘッダー画像などのsrcを取得 */
  private imgSrc() {
    const filePath = this.account?.headerImage;
    const prefix = `accounts/${this.account?.accountId}/account_images`;
    return `https://osha-p.com/${prefix}/${filePath}`;
  }

  /** アカウント足跡一覧取得メソッド(2回目以降)を定義 */
  private async onNextGetAccountFootprints(params: {
    lastId: number | null;
    lastCreatedAt: Date | null;
  }) {
    this.loading = true;
    const query: FindAccountFootprintsQuery =
      params.lastId && params.lastCreatedAt
        ? {
            count: 2,
            'last-account-footprint-id': params.lastId,
            'last-created-at': params.lastCreatedAt,
          }
        : { count: 2 };
    await vxm.theoryApi.accountsStore.fetchAccountFootprints({
      accountId: this.accountId,
      query: query,
    });
    this.loading = false;
    return;
  }

  private get getAccount(): Account | null {
    return vxm.theoryApi.accountsStore.getAccountDetail?.results ?? null;
  }

  private get accountId(): number {
    return vxm.theoryApi.authStore.getCurrentUserInfo?.results.accountId ?? 0;
  }

  private get accountTotalFootprints(): number | undefined {
    return vxm.theoryApi.accountsStore.getAccountTotalFootprints?.results
      .footprintsNumber;
  }

  private get getAccountParticipationProjects(): AccountParticipationProject[] {
    return vxm.theoryApi.accountsStore.getAccountParticipationProjects?.results ?? [];
  }
}
